// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFileErrorDto
 */
export interface IFileErrorDto {
    /**
     * 
     * @type {number}
     * @memberof IFileErrorDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IFileErrorDto
     */
    file_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IFileErrorDto
     */
    error_details?: string;
    /**
     * 
     * @type {string}
     * @memberof IFileErrorDto
     */
    file_error_type?: IFileErrorDtoFileErrorTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IFileErrorDto
     */
    created_at?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IFileErrorDtoFileErrorTypeEnum {
    STORE_ERROR = 'STORE_ERROR',
    VALIDATION_ERROR = 'VALIDATION_ERROR',
    PARSING_ERROR = 'PARSING_ERROR',
    QUALITY_GATES_ERROR = 'QUALITY_GATES_ERROR',
    ERROR = 'ERROR',
    ENCODING_ERROR = 'ENCODING_ERROR',
    PERMISSION_ERROR = 'PERMISSION_ERROR'
}


/**
 * Check if a given object implements the IFileErrorDto interface.
 */
export function instanceOfIFileErrorDto(value: object): value is IFileErrorDto {
    return true;
}

export function IFileErrorDtoFromJSON(json: any): IFileErrorDto {
    return IFileErrorDtoFromJSONTyped(json, false);
}

export function IFileErrorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFileErrorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'file_id': json['file_id'] == null ? undefined : json['file_id'],
        'error_details': json['error_details'] == null ? undefined : json['error_details'],
        'file_error_type': json['file_error_type'] == null ? undefined : json['file_error_type'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
    };
}

export function IFileErrorDtoToJSON(json: any): IFileErrorDto {
    return IFileErrorDtoToJSONTyped(json, false);
}

export function IFileErrorDtoToJSONTyped(value?: IFileErrorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'file_id': value['file_id'],
        'error_details': value['error_details'],
        'file_error_type': value['file_error_type'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
    };
}

